import React from "react";
import { Typography } from '@progress/kendo-react-common';

export const HeadingText = (props) => {

    switch(props.type) {
        case "h1":
            return (<Typography.h1 {...props}>{props.children}</Typography.h1>)
        case "h2":
            return (<Typography.h2 {...props}>{props.children}</Typography.h2>)
        case "h3":
            return (<Typography.h3 {...props}>{props.children}</Typography.h3>)
        case "h4":
            return (<Typography.h4 {...props}>{props.children}</Typography.h4>)
        case "h5":
            return (<Typography.h5 {...props}>{props.children}</Typography.h5>)
        case "h6":
            return (<Typography.h6 {...props}>{props.children}</Typography.h6>)
        default:
            return (<Typography.h1 {...props}>{props.children}</Typography.h1>)
    }

}